import { createSlice } from '@reduxjs/toolkit'
import { LegalDocumentDescription as Legal } from '@types'

type InitialStateType = {
  allLegals: Legal[]
  isLoading: boolean
}

const initialState: InitialStateType = {
  allLegals: [],
  isLoading: true
}

const slice = createSlice({
  name: 'legals',
  initialState,
  reducers: {
    getAllLegals(state, action) {
      state.allLegals = Array.isArray(action.payload) ? [...action.payload]: []
      state.isLoading = false
    }
  }
})

export const { getAllLegals } = slice.actions

export default slice.reducer
